<script lang="ts">
  import Button from '../lib/ui/Button.svelte';
  import Drawer from '../lib/ui/Drawer.svelte';
  import Notice from '../lib/ui/Notice.svelte';
  import TenantPicker from './TenantPicker.svelte';
  import { TenantSearch } from '../lib/tenant-search.svelte';
  import type { ReportDefinitionGroup, ReportDefinitionTenant } from '../lib/api';
  import type { ReportDefinitionsBoard } from '../lib/report-definitions-board.svelte';

  interface Props {
    board: ReportDefinitionsBoard;
    group: ReportDefinitionGroup;
    onChoose: (tenant: ReportDefinitionTenant) => void;
    onClose: () => void;
  }

  let { board, group, onChoose, onClose }: Props = $props();

  const search = new TenantSearch(() => board.tenants);
  let chosen = $state<ReportDefinitionTenant | null>(null);

  function proceed(): void {
    if (!chosen) return;
    onChoose(chosen);
  }
</script>

<Drawer eyebrow={group.name} title="Adicionar cliente" {onClose}>
  {#if board.error}
    <Notice tone="danger">{board.error}</Notice>
  {/if}
  <TenantPicker
    {search}
    {chosen}
    onChoose={(tenant) => (chosen = tenant)}
    isDisabled={(tenant) => board.isInGroup(group, tenant)}
    disabledNote="Já está neste relatório"
  />
  {#snippet footer()}
    <Button onclick={onClose}>Cancelar</Button>
    <Button variant="primary" disabled={!chosen} onclick={proceed}>Continuar</Button>
  {/snippet}
</Drawer>
